import { useScanSoundSettingsStore } from '../../store/scanSoundSettingsStore';
import { playEnqueuedScanSound } from './scanSoundUtils';

const VIBRATE_DURATION_MS = 200;

// 扫描反馈三合一：声音 / 震动 / 呼吸灯，各自由对应开关独立控制
// master=false 时跳过整套（用户走 SDK 自带反馈语义）
export const triggerScanFeedback = (): void => {
  const { masterEnabled, soundEnabled, vibrateEnabled } = useScanSoundSettingsStore.getState();
  if (!masterEnabled) return;

  if (soundEnabled) {
    void playEnqueuedScanSound().catch(() => {});
  }

  if (vibrateEnabled) {
    try {
      navigator.vibrate?.(VIBRATE_DURATION_MS);
    } catch {
      // PDA WebView 不支持 navigator.vibrate 时静默
    }
  }

  // todo <sunruixin>: 呼吸灯硬件接通后在此处加 mobile-web 主动控制（当前由 SDK 按 master 反向代闪）
};
